export default __webpack_public_path__ + "static/media/sample-resume.6224bc58.png";